<div class="report-container flex flex-col min-h-screen w-full h-full">
  <app-title-section [title]="'Signalements'"></app-title-section>
  <p class="subtitle ml-1">Gérer tous les signalements de contenu</p>
   <p-divider />
  <div class="report-content flex flex-col gap-y-8 h-full">
    @if (isLoading() === false) {
        <div class="card">
            <h2 class="mb-8">Catégories de signalement (Loi française)</h2>
            <app-report-category [categories]="categories()"></app-report-category>
        </div>

        <div class="card">
            <p-table
                #dt2
                [value]="reports()"
                dataKey="id"
                [rows]="10"
                [rowsPerPageOptions]="[10, 25, 50]"
                [paginator]="true"
            >
                <ng-template #header>
                    <tr>
                        <th>Page</th>
                        <th>Catégorie</th>
                        <th>Utilisateur</th>
                        <th>Type</th>
                        <th>Statut</th>
                        <th>Date</th>
                        <th>Actions</th>
                    </tr>
                </ng-template>
                <ng-template #body let-report>
                    <tr>
                        <td class="font-medium">
                            {{ mapPageNameToString(asReport(report).page) | capitalize }}
                        </td>
                        <td>
                            {{ asReport(report).category.title }}
                        </td>
                        <td>
                            {{ asReport(report).reportedUser.displayName }}
                        </td>
                        <td>
                            {{ asReport(report).contentType }}
                        </td>
                        <td>
                            <p-tag 
                            [severity]="mapReportStatusToSeverity(asReport(report).status)"
                            [value]="mapReportStatusToString(asReport(report).status) | capitalize" />
                        </td>
                        <td>
                            {{ asReport(report).createdAt | date:'dd MMM yyyy' : '' : 'fr-FR' }}
                        </td>
                        <td>
                            <div class="p-2 w-fit cursor-pointer" (click)="openDialog(asReport(report))">
                                <app-icon-svg width="15" height="15" iconName="security-eye" color="#57636c"></app-icon-svg>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template #emptymessage>
                    <tr>
                        <td colspan="5">Aucun utilisateur trouvé</td>
                    </tr>
                </ng-template>
            </p-table>

            @if (selectedReport(); as report) {
                <p-dialog class="pb-0" [header]="'Signalement ' + mapPageNameToString(report.page)" [modal]="true" [(visible)]="isDialogVisible" [style]="{ width: '30rem' }">
                    <span class="page-1-description text-[14px] font-medium block mb-8">{{ report.category.title }} - {{ report.contentType }}</span>
                    <p-selectbutton [options]="stateOptions" fluid [(ngModel)]="subModalValue" optionLabel="label" optionValue="value" aria-labelledby="basic" />
                    @if(subModalValue === "details") {
                        <div class="page-1-category flex gap-x-2 p-4 mt-8">
                            <app-icon-svg class="pt-1" width="15" height="15" iconName="tooltip" color="#ffce34"></app-icon-svg>
                            <div>
                                <p class="font-medium text-[18px]">{{ report.category.title }}</p>
                                <p class="font-medium text-[14px]">{{ report.category.description }}</p>
                            </div>
                        </div>
                        @if (report.reportedContent) {
                            <p class="font-semibold text-[14px] mt-8 mb-2 title">Contenu signalé</p>
                            <div class="page-1-reported p-4">
                                <p class="font-medium text-[14px]">"{{ report.reportedContent }}"</p>
                            </div>
                        }
                        <p class="font-semibold text-[14px] mt-8 mb-2 title">Raison du signalement</p>
                        <div class="page-1-reason p-4 flex items-center gap-x-4">
                            <app-icon-svg width="15" height="15" iconName="comment" color="#57636c"></app-icon-svg>
                            <p class="font-medium text-[14px]">{{ report.reason }}</p>
                        </div>
                        <div class="flex items-center gap-x-2 my-4">
                            <app-icon-svg width="12" height="12" iconName="time" color="#57636c"></app-icon-svg>
                            <p class="font-medium text-[12px] reason-content">Crée le {{ report.createdAt | date:'dd MMM yyyy' : '' : 'fr-FR' }}</p>
                        </div>
                    } @else if(subModalValue === "users") {
                        <div class="page-2-reported-user flex flex-col gap-x-2 p-4 mt-8">
                            <p class="font-semibold text-[14px] mb-2 uppercase title">Utilisateur signalé</p>
                            <div class="user mt-2 flex items-center gap-x-2">
                                <div class="avatar w-[60px] h-[60px] shrink-0">
                                    <img [src]="report.reportedUser.photoUrl" alt="Avatar">
                                </div>
                                <div class="user-details flex justify-between items-center w-full min-w-0">
                                    <p class="font-semibold">{{ report.reportedUser.displayName }}</p>
                                    <p-tag 
                                    [value]="getTagValueFromAccountStatus(report.reportedUser.accountStatus)" 
                                    [severity]="getSeverityTagFromAccountStatus(report.reportedUser.accountStatus)" />
                                </div>
                            </div>
                            <p-divider />
                            <div class="user-additional-details flex items-center justify-between">
                                <div class="flex flex-col">
                                    <p class="font-semibold text-[20px] text-center">{{report.reportedUser.totalReports}}</p>
                                    <p class="text-[14px] text-center">Signalements</p>
                                </div>
                                <div class="flex flex-col">
                                    <p class="font-semibold text-[20px] text-center">{{report.reportedUser.totalSanctions}}</p>
                                    <p class="text-[14px] text-center">Sanctions</p>
                                </div>
                                <div class="flex flex-col">
                                    <p class="font-semibold text-[18px] text-center">{{report.reportedUser.createdAt | date:'MMM yyyy' : '' : 'fr-FR'}}</p>
                                    <p class="text-[14px] text-center">Inscription</p>
                                </div>
                            </div>
                        </div>
                        <div class="page-2-reporter-user flex flex-col gap-x-2 p-4 mt-8">
                            <p class="font-semibold text-[14px] mb-2 uppercase title">Auteur du signalement</p>
                            <div class="user mt-2 flex items-center gap-x-2">
                                <div class="avatar w-[60px] h-[60px] shrink-0">
                                    <img [src]="report.reporterUser.photoUrl" alt="Avatar">
                                </div>
                                <div class="user-details flex justify-between items-center w-full min-w-0">
                                    <p class="font-semibold">{{ report.reportedUser.displayName }}</p>
                                    <p-tag 
                                    [value]="getTagValueFromAccountStatus(report.reporterUser.accountStatus)" 
                                    [severity]="getSeverityTagFromAccountStatus(report.reporterUser.accountStatus)" />
                                </div>
                            </div>
                        </div>
                    } @else {
                        <div class="page-3-actions flex flex-col gap-x-2 mt-8">
                            <p class="font-semibold text-[14px] mb-2 title">Sanction à appliquer</p>
                            <p-select [options]="computedSanctionsOptions" [(ngModel)]="sanctionsCode" optionLabel="name" optionValue="code" class="w-full md:w-56" />
                            <p class="font-semibold text-[14px] mt-8 mb-2 title">Note du modérateur</p>
                            <textarea rows="5" cols="30" pTextarea [(ngModel)]="textAreaValue" fluid placeholder="Ajoutez des notes pour justifier votre décision..."></textarea>
                            @if (!isResolved(report) && isBlockedByCooldown(report)) {
                                <p class="mt-4 p-3 rounded-lg bg-yellow-50 text-yellow-700 text-sm flex items-center gap-2">
                                    <app-icon-svg width="18" height="18" iconName="tooltip" color="#b08a00"></app-icon-svg>
                                    La dernière action sur cet utilisateur a été effectuée il y a moins de 7 jours. 
                                    Sauf en cas de conséquence nécessitant une intervention urgente, aucune nouvelle action ne doit être appliquée avant la fin de ce délai.
                                </p>
                            }
                            <div class="cta mt-8 flex gap-x-2 justify-end">
                                <button 
                                class="reject-btn px-4 py-2" 
                                pButton 
                                [disabled]="isResolved(report) || isBlockedByCooldown(report)" 
                                (click)="rejectReport()">
                                Rejeter
                            </button>
                                <button 
                                class="apply-btn px-4 py-2" 
                                pButton 
                                [disabled]="isResolved(report) || isBlockedByCooldown(report)" 
                                (click)="applySanction(selectedReport()!)">
                                Appliquer la sanction
                            </button>
                            </div>
                        </div>
                    }
                </p-dialog>
            }
        </div>
    } @else {
    <!-- Loading -->
    <div class="loading-spinner flex justify-center">
      <p-progress-spinner strokeWidth="8" fill="transparent" animationDuration=".5s" class="progress-spinner" />
    </div>
    }
  </div>